export enum RoutesEnum {
	home = 'home',
	order = 'buy',
	storeSelection = 'store-selection',
	shoppingCart = 'cart',
	profile = 'profile',
	categories = 'category',
	test = 'test',
	blankPage = 'blank',
	settings = 'settings',
	noService = 'no-service',
}
